import { Component } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { ChangeRequestWidgetComponent } from '@app/dashboard/widgets/change-request-widget/change-request-widget.component';
import { FailedTasksWidgetComponent } from '@app/dashboard/widgets/failed-tasks-widget/failed-tasks-widget.component';
import { MoneybarWidgetComponent } from '@app/dashboard/widgets/moneybar-widget/moneybar-widget.component';
import { PausedDonationsWidgetComponent } from '@app/dashboard/widgets/paused-donations-widget/paused-donations-widget.component';
import { StoppedDonationsWidgetComponent } from '@app/dashboard/widgets/stopped-donations-widget/stopped-donations-widget.component';
import { SurveySearchWidgetComponent } from '@app/dashboard/widgets/survey-search-widget/survey-search-widget.component';
import { SurveySummaryWidgetComponent } from '@app/dashboard/widgets/survey-summary-widget/survey-summary-widget.component';
import { WorkflowTaskWidgetComponent } from '@app/dashboard/widgets/workflow-task-widget/workflow-task-widget.component';
import { Permissions } from '@core/constants/permissions';
import { NgxPermissionsModule } from 'ngx-permissions';

import { GroupOverviewWidgetComponent } from './widgets/group-overview-widget/group-overview-widget.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    NgxPermissionsModule,
    MoneybarWidgetComponent,
    SurveySearchWidgetComponent,
    WorkflowTaskWidgetComponent,
    ChangeRequestWidgetComponent,
    SurveySummaryWidgetComponent,
    FailedTasksWidgetComponent,
    GroupOverviewWidgetComponent,
    PausedDonationsWidgetComponent,
    StoppedDonationsWidgetComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  protected readonly permissions = Permissions;
}
